import { complete_sso_login } from "@/router";

export default {
  name: "SsoAssertView",

  mounted() {
    this.handle_assertion_redirect();
  },

  methods: {
    async handle_assertion_redirect() {
      const token = this.$route.query.token;
      const raw_payload = this.$route.query.payload;

      if (!token || !raw_payload) {
        this.$router.replace("/login");
        return;
      }

      try {
        await complete_sso_login(token, raw_payload);
        this.$router.replace("/home");
      } catch (error) {
        console.error("Could not complete SSO login:", error);
        this.$router.replace("/login");
      }
    }
  }
};
